'use client';

import { Disclosure, DisclosurePanel, DisclosureButton } from '@headlessui/react';
import { Fragment } from 'react';
import { ChevronDown } from 'lucide-react';
import Link from 'next/link';
import { clsx } from 'clsx';

import { SIDEBAR_NAVIGATIONS } from '@lib/constants/navigations';
import { ExpandedMenuFilters } from './filters';
import { useHeaderStore } from '@lib/stores/useHeaderStore';
import { Button } from '@components/common/button';
import { Separator } from '@components/common/separator';

export function ExpandedMenuLinks() {
  const { setOpenSheet, setCategory } = useHeaderStore();

  return (
    <ul className="space-y-4">
      {SIDEBAR_NAVIGATIONS.map((nav, index) => (
        <Fragment key={nav.label}>
          {index > 0 && <Separator />}
          <li>
            <div className="px-6">
              {nav.href ? (
                <Button
                  asChild
                  variant="link"
                  onClick={() => setOpenSheet(false)}
                  className="text-lg xl:text-xl font-medium p-0 w-fit h-auto text-gray-600"
                >
                  <Link href={nav.href}>{nav.label}</Link>
                </Button>
              ) : nav.value ? (
                <Disclosure>
                  {({ open }) => (
                    <div>
                      <DisclosureButton
                        onClick={nav.value ? () => setCategory(nav.value) : undefined}
                        className={clsx(
                          'flex-between w-full hover:text-foreground font-medium text-lg xl:text-xl focus:outline-none',
                          open ? 'text-foreground' : 'text-gray-600'
                        )}
                      >
                        {nav.label}
                        <ChevronDown
                          aria-hidden="true"
                          className={clsx(
                            'size-4 transition-transform duration-200 ease-linear',
                            open && 'rotate-180'
                          )}
                        />
                      </DisclosureButton>
                      <DisclosurePanel>
                        <ExpandedMenuFilters onClose={() => setOpenSheet(false)} />
                      </DisclosurePanel>
                    </div>
                  )}
                </Disclosure>
              ) : null}
            </div>
          </li>
        </Fragment>
      ))}
    </ul>
  );
}
